<!-- Welcome Section -->
<section class="welcome-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="welcome-content">
          <h1 class="welcome-title">{{ 'about.hero.title' | translate }}</h1>
          <p class="welcome-text">{{ 'about.hero.subtitle' | translate }}</p>
          @if (isLoggedIn) {
            <a routerLink="/user-profile" class="btn-welcome">
              {{ 'home.hero.goToProfile' | translate }}
              <i class="fa fa-arrow-right ms-2"></i>
            </a>
          } @else {
            <a routerLink="/auth/register-user" class="btn-welcome">
              {{ 'about.hero.getStarted' | translate }}
              <i class="fa fa-arrow-right ms-2"></i>
            </a>
          }
        </div>
      </div>
      <div class="col-lg-6">
        <div class="welcome-image">
          <img src="/assets/images/TfDRbs3L.jpeg" alt="Horse community" />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Problem & Solution Section - Two Columns -->
<section class="problem-solution-section">
  <div class="container">
    <div class="row g-5 align-items-stretch">
      <!-- Left Column: Why we built HorseLoop -->
      <div class="col-lg-6">
        <div class="solution-column">
          <div class="solution-icon">
            <i class="fa fa-heart"></i>
          </div>
          <h2>{{ 'about.solution.title' | translate }}</h2>
          <p>{{ 'about.solution.text1' | translate }}</p>
          <p>{{ 'about.solution.text2' | translate }}</p>
          <div class="solution-quote">
            <i class="fa fa-quote-left"></i>
            <span>{{ 'about.solution.quote' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Right Column: The problems -->
      <div class="col-lg-6">
        <div class="problem-column">
          <div class="problem-icon-header">
            <i class="fa fa-lightbulb"></i>
          </div>
          <h2>{{ 'about.problem.title' | translate }}</h2>
          <p [innerHTML]="'about.problem.intro' | translate"></p>
          <ul class="problem-bullets">
            <li><i class="fa fa-hashtag"></i> {{ 'about.problem.bullet1' | translate }}</li>
            <li><i class="fa fa-clock"></i> {{ 'about.problem.bullet2' | translate }}</li>
            <li><i class="fa fa-envelope"></i> {{ 'about.problem.bullet3' | translate }}</li>
            <li><i class="fa fa-credit-card"></i> {{ 'about.problem.bullet4' | translate }}</li>
          </ul>
          <div class="problem-quote">
            <i class="fa fa-quote-left"></i>
            <span>{{ 'about.problem.quote' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- For Everyone Section -->
<section class="everyone-section">
  <div class="container">
    <div class="row g-5">
      <!-- For Riders -->
      <div class="col-lg-4">
        <div class="audience-block">
          <div class="audience-icon">
            <i class="fa fa-horse-head"></i>
          </div>
          <h3>{{ 'about.riders.title' | translate }}</h3>
          <p>{{ 'about.riders.text1' | translate }}</p>
        </div>
      </div>

      <!-- For Organizations -->
      <div class="col-lg-4">
        <div class="audience-block">
          <div class="audience-icon">
            <i class="fa fa-users"></i>
          </div>
          <h3>{{ 'about.businesses.title' | translate }}</h3>
          <p>{{ 'about.businesses.text1' | translate }}</p>
        </div>
      </div>

      <!-- For Service Providers -->
      <div class="col-lg-4">
        <div class="audience-block">
          <div class="audience-icon">
            <i class="fa fa-store"></i>
          </div>
          <h3>{{ 'about.services.title' | translate }}</h3>
          <p>{{ 'about.services.text1' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- What We Offer Section - COMMENTED OUT
<section class="offer-section">
  <div class="container">
    <div class="text-center mb-5">
      <span class="section-tag">{{ 'about.features.badge' | translate }}</span>
      <h2 class="section-heading">{{ 'about.features.title' | translate }}</h2>
    </div>

    <div class="offer-grid">
      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-calendar-check"></i>
        </div>
        <h4>{{ 'about.features.eventsTitle' | translate }}</h4>
        <p>{{ 'about.features.eventsDesc' | translate }}</p>
      </div>

      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-credit-card"></i>
        </div>
        <h4>{{ 'about.features.paymentTitle' | translate }}</h4>
        <p>{{ 'about.features.paymentDesc' | translate }}</p>
      </div>

      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-id-card"></i>
        </div>
        <h4>{{ 'about.features.membershipTitle' | translate }}</h4>
        <p>{{ 'about.features.membershipDesc' | translate }}</p>
      </div>

      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-horse"></i>
        </div>
        <h4>{{ 'about.features.horsesTitle' | translate }}</h4>
        <p>{{ 'about.features.horsesDesc' | translate }}</p>
      </div>

      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-trophy"></i>
        </div>
        <h4>{{ 'about.features.resultsTitle' | translate }}</h4>
        <p>{{ 'about.features.resultsDesc' | translate }}</p>
      </div>

      <div class="offer-item">
        <div class="offer-icon">
          <i class="fa fa-mobile-alt"></i>
        </div>
        <h4>{{ 'about.features.mobileTitle' | translate }}</h4>
        <p>{{ 'about.features.mobileDesc' | translate }}</p>
      </div>
    </div>
  </div>
</section>
-->

<!-- Community Section -->
<section class="community-stats-section">
  <div class="container text-center">
    <img src="/assets/images/horseloop-logo.png" alt="HorseLoop" class="community-logo" />
    <h2 class="stats-heading" style="color: white">{{ 'about.stats.title' | translate }}</h2>
  </div>
</section>

<!-- Getting Started Section -->
<section class="started-section">
  <div class="container">
    <div class="text-center mb-5">
      <span class="section-tag">{{ 'about.getStarted.badge' | translate }}</span>
      <h2 class="section-heading">{{ 'about.getStarted.title' | translate }}</h2>
      <p class="section-desc">{{ 'about.getStarted.subtitle' | translate }}</p>
    </div>

    <div class="steps-row">
      <div class="step-box">
        <div class="step-icon">
          <i class="fa fa-user-plus"></i>
        </div>
        <h4>{{ 'about.getStarted.step1Title' | translate }}</h4>
        <p>{{ 'about.getStarted.step1Desc' | translate }}</p>
      </div>

      <div class="step-connector">
        <i class="fa fa-arrow-right"></i>
      </div>

      <div class="step-box">
        <div class="step-icon">
          <i class="fa fa-horse-head"></i>
        </div>
        <h4>{{ 'about.getStarted.step2Title' | translate }}</h4>
        <p>{{ 'about.getStarted.step2Desc' | translate }}</p>
      </div>

      <div class="step-connector">
        <i class="fa fa-arrow-right"></i>
      </div>

      <div class="step-box">
        <div class="step-icon">
          <i class="fa fa-calendar-plus"></i>
        </div>
        <h4>{{ 'about.getStarted.step3Title' | translate }}</h4>
        <p>{{ 'about.getStarted.step3Desc' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Contact Section -->
<section class="contact-us-section">
  <div class="container">
    <div class="contact-card">
      <div class="contact-content">
        <span class="section-tag light">{{ 'about.contact.badge' | translate }}</span>
        <h2>{{ 'about.contact.title' | translate }}</h2>
        <p>{{ 'about.contact.subtitle' | translate }}</p>
        <a href="mailto:hello@horseloop.no" class="contact-link">
          <i class="fa fa-envelope"></i>
          <span>hello&#64;horseloop.no</span>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Feature Comparison Table Section -->
<section class="feature-comparison-section">
  <div class="container">
    <div class="text-center mb-5">
      <span class="section-tag">{{ 'featureComparison.pricing.perYear' | translate }}</span>
      <h2 class="section-heading">{{ 'featureComparison.title' | translate }}</h2>
      <p class="section-desc">{{ 'featureComparison.subtitle' | translate }}</p>
    </div>

    <div class="feature-table-wrapper">
      <table class="feature-table">
        <thead>
          <tr>
            <th class="feature-column">{{ 'featureComparison.featureColumn' | translate }}</th>
            <th>
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.stable' | translate }}</span>
                <span class="org-price free">{{ 'featureComparison.pricing.free' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.ridingClub' | translate }}</span>
                <span class="org-price free">{{ 'featureComparison.pricing.free' | translate }}</span>
              </div>
            </th>
            <th class="featured-col">
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.ridingClubPro' | translate }}</span>
                <span class="org-price">2999 {{ 'featureComparison.pricing.perYear' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.storeService' | translate }}</span>
                <span class="org-price">299 {{ 'featureComparison.pricing.perYear' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.trainer' | translate }}</span>
                <span class="org-price">299 {{ 'featureComparison.pricing.perYear' | translate }}</span>
              </div>
            </th>
            <th class="coming-soon-col">
              <div class="org-header">
                <span class="org-name">{{ 'featureComparison.types.ridingSchool' | translate }}</span>
                <span class="org-price coming-soon">{{ 'featureComparison.pricing.comingSoon' | translate }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Core Features Category -->
          <tr class="category-row">
            <td colspan="7">{{ 'featureComparison.categories.core' | translate }}</td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.profile' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.contact' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.socialMedia' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.gallery' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.documents' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.feed' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.sponsors' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.chat' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>

          <!-- Premium Features Category -->
          <tr class="category-row">
            <td colspan="7">{{ 'featureComparison.categories.premium' | translate }}</td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.events' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.trainingEvents' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.competitionEvents' | translate }}</td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><span class="dash">-</span></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.services' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.memberships' | translate }}</td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.memberDiscounts' | translate }}</td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.deals' | translate }}</td>
            <td><span class="dash">-</span></td>
            <td><span class="dash">-</span></td>
            <td class="featured-col"><span class="dash">-</span></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><span class="dash">-</span></td>
          </tr>
          <tr>
            <td class="feature-name">{{ 'featureComparison.features.payments' | translate }}</td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td class="featured-col"><i class="fa fa-check text-success"></i></td>
            <td><i class="fa fa-check text-success"></i></td>
            <td><span class="dash">-</span></td>
            <td class="coming-soon-col"><i class="fa fa-check text-success"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<!-- Final CTA Section -->
<section class="final-cta-section">
  <div class="container text-center">
    <h2>{{ 'about.cta.title' | translate }}</h2>
    <p>{{ 'about.cta.subtitle' | translate }}</p>
    <div class="cta-buttons">
      @if (isLoggedIn) {
        <a routerLink="/user-profile" class="btn-cta-warm">
          {{ 'home.hero.goToProfile' | translate }}
          <i class="fa fa-arrow-right ms-2"></i>
        </a>
        <a routerLink="/shows" class="btn-cta-outline">
          {{ 'home.hero.browseEvents' | translate }}
          <i class="fa fa-arrow-right ms-2"></i>
        </a>
      } @else {
        <a routerLink="/auth/register-user" class="btn-cta-warm">
          {{ 'about.cta.participantButton' | translate }}
          <i class="fa fa-arrow-right ms-2"></i>
        </a>
        <a routerLink="/auth/register-user" class="btn-cta-outline">
          {{ 'about.cta.organizationButton' | translate }}
          <i class="fa fa-arrow-right ms-2"></i>
        </a>
      }
    </div>
  </div>
</section>
